import { PEOPLE_AUDIENCE, PREVIEW_ARTICLE, USER_ENTITIES } from 'constants/actionTypes';
import store from '../store/index';
import { getPreviewArticlesService } from './Services/EmailService';

export const GLOBAL_ACTION = {
  PREVIEW_LOADING: 'PREVIEW_LOADING',
  OPEN_OVERLAY: 'OPEN_OVERLAY',
  CLOSE_OVERLAY: 'CLOSE_OVERLAY',
  OPEN_CURATION_HISTORY: 'OPEN_CURATION_HISTORY',
  CLOSE_CURATION_HISTORY: 'CLOSE_CURATION_HISTORY',
  OPEN_CURATION_SIDEBAR: 'OPEN_CURATION_SIDEBAR',
  CLOSE_CURATION_SIDEBAR: 'CLOSE_CURATION_SIDEBAR',
  OPEN_ARTICLE_SIDEBAR_PREVIEW: 'OPEN_ARTICLE_SIDEBAR_PREVIEW',
  CLOSE_ARTICLE_SIDEBAR_PREVIEW: 'CLOSE_ARTICLE_SIDEBAR_PREVIEW',
  ARTICLE_PREVIEW: 'ARTICLE_PREVIEW',
  OPEN_DETAIL_PROFILE: 'OPEN_DETAIL_PROFILE',
  CLOSE_DETAIL_PROFILE: 'CLOSE_DETAIL_PROFILE',
  OPEN_CREATE_CONTACT_FORM: 'OPEN_CREATE_CONTACT_FORM',
  CLOSE_CREATE_CONTACT_FORM: 'CLOSE_CREATE_CONTACT_FORM',
  OPEN_CREATE_ASSET_SIDEBAR: 'OPEN_CREATE_ASSET_SIDEBAR',
  CLOSE_CREATE_ASSET_SIDEBAR: 'CLOSE_CREATE_ASSET_SIDEBAR',
  OPEN_CREATE_NEW_CAMPAIGN_SIDEBAR: 'OPEN_CREATE_NEW_CAMPAIGN_SIDEBAR',
  CLOSE_CREATE_NEW_CAMPAIGN_SIDEBAR: 'CLOSE_CREATE_NEW_CAMPAIGN_SIDEBAR',
  ENABLE_STICKY_HEADER: 'ENABLE_STICKY_HEADER',
  DISABLE_STICKY_HEADER: 'DISABLE_STICKY_HEADER',
  BODY_BOL_FLAG: 'BODY_BOL_FLAG',
  SET_CONFIRM_BACK_OVERLAY: 'GLOBAL_ACTION_SET_CONFIRM_BACK_OVERLAY',
  SET_MAIN_NAV_DARK_OVERLAY: 'GLOBAL_ACTION_SET_MAIN_NAV_DARK_OVERLAY',
  SET_STICKY_HEADER_BACK_OVERLAY: 'GLOBAL_ACTION_SET_STICKY_HEADER_BACK_OVERLAY',
  IMPORT_LIST_POPOVER: 'GLOBAL_ACTION_IMPORT_LIST_POPOVER',
  CLOSE_CREATE_NEW_LIST_ASIDER: 'GLOBAL_ACTION_CLOSE_CREATE_NEW_LIST_ASIDER',
  OPEN_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE: 'GLOBAL_ACTION_OPEN_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE',
  CLOSE_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE: 'GLOBAL_ACTION_CLOSE_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE',
  DETAIL_PROFILE_SCROLL_CHECK: 'GLOBAL_ACTION_DETAIL_PROFILE_SCROLL_CHECK',
  ARTICLE_DIV_SCROLL_CHECK: 'GLOBAL_ACTION_ARTICLE_DIV_SCROLL_CHECK',
  CLOSE_ADVANCED_SEARCH_SIDEBAR: 'GLOBAL_ACTION_CLOSE_ADVANCED_SEARCH_SIDEBAR',
  OPEN_ADVANCED_SEARCH_SIDEBAR: 'GLOBAL_ACTION_OPEN_ADVANCED_SEARCH_SIDEBAR',
  ADVANCED_SEARCH: 'GLOBAL_ACTION_ADVANCED_SEARCH',
  ADVANCED_SEARCH_CHECK: 'GLOBAL_ACTION_ADVANCED_SEARCH_CHECK',
  EMAIL_CREATED_CHECK: 'GLOBAL_ACTION_EMAIL_CREATED_CHECK',
  APPLY_AUDIENCE_FILTERS: 'GLOBAL_ACTION_APPLY_AUDIENCE_FILTERS',
  AUDIENCE_FILTERS_APPLIED: 'GLOBAL_ACTION_AUDIENCE_FILTERS_APPLIED',
  NEW_LIST_ASIDER_OPEN_STATE: 'GLOBAL_ACTION_NEW_LIST_ASIDER_OPEN_STATE',
  CLOSE_CREATE_NEW_LIST_ASIDER_FROM_CANCEL: 'GLOBAL_ACTION_CLOSE_CREATE_NEW_LIST_ASIDER_FROM_CANCEL',
  SET_SMALL_RESOLUTION_MODAL: 'GLOBAL_ACTION_SET_SMALL_RESOLUTION_MODAL',
};

export const setSmallResolutionAlertModal = (val: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.SET_SMALL_RESOLUTION_MODAL,
    payload: val,
  });
};

export const openOverlay = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_OVERLAY,
  });
};

export const closeOverlay = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_OVERLAY,
  });
  store.dispatch({
    type: GLOBAL_ACTION.BODY_BOL_FLAG,
    payload: false,
  });
};

export const dynamicBody = () => {
  store.dispatch({
    type: GLOBAL_ACTION.BODY_BOL_FLAG,
    payload: true,
  });
};

export const openCurationHistory = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_CURATION_HISTORY,
  });
};

export const closeCurationHistory = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CURATION_HISTORY,
  });
};

export const openCurationSidebar = () => {
  let previewOpen = store.getState().previewArticle.openPreview;
  /**
   ** thie following condition is catering a situation for firefox where
   ** if a user click article and slide a bit to open preview
   ** it was also opening email builder in the background.
   */
  if (previewOpen) {
    openOverlay();
    return;
  }
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_CURATION_SIDEBAR,
  });
  openOverlay();
};

export const closeCurationSidebar = () => {
  closeCurationHistory();
  closeOverlay();
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CURATION_SIDEBAR,
  });
};

export const openArticleSidebarPreview = (article: any, inEdition?: boolean) => {
  store.dispatch({ type: GLOBAL_ACTION.PREVIEW_LOADING, loading: true });
  setTimeout(() => {
    !inEdition
      ? store.dispatch({
          type: GLOBAL_ACTION.OPEN_ARTICLE_SIDEBAR_PREVIEW,
          payload: article,
        })
      : store.dispatch({
          type: GLOBAL_ACTION.ARTICLE_PREVIEW,
          payload: article,
        });
    !inEdition && openOverlay();

    getPreviewArticlesService(article?.id)
      .then((res) => {
        // check if the article preview is opened and is actuive article
        let isOpen = store.getState().previewArticle.openPreview;
        let articleId = article?.id;
        let activeArticleId = store.getState().previewArticle.activeArticle.id;
        if ((isOpen || inEdition) && (activeArticleId === 0 || activeArticleId === articleId)) {
          store.dispatch({
            type: PREVIEW_ARTICLE.LOAD_SUCCESS,
            data: res.data,
          });
        }
        store.dispatch({ type: GLOBAL_ACTION.PREVIEW_LOADING, loading: false });
      })
      .catch((err) => {
        store.dispatch({ type: PREVIEW_ARTICLE.LOAD_FAIL });
      });
  }, 100);
};

export const closeArticleSidebarPreview = (articleSidebarPreviewInDetailProfile?: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_ARTICLE_SIDEBAR_PREVIEW,
  });
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE,
  });
  !articleSidebarPreviewInDetailProfile && closeOverlay();
};

export const openDetailProfile = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_DETAIL_PROFILE,
  });
  openOverlay();
};

export const openCreateNewContactSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_CREATE_CONTACT_FORM,
  });
  store.dispatch({
    type: PEOPLE_AUDIENCE.RESET_EDIT_CONTACT,
  });
  // openOverlay();
};

export const closeCreateNewContactSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CREATE_CONTACT_FORM,
  });
  closeOverlay();
};

export const closeEditContactSidebar = () => {
  store.dispatch({
    type: PEOPLE_AUDIENCE.CLOSE_EDIT_CONTACT_SIDEBAR,
  });
  closeOverlay();
};

export const closeCreateNewListAsider = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CREATE_NEW_LIST_ASIDER,
  });
};

export const closeDetailProfile = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_DETAIL_PROFILE,
  });
  closeOverlay();
};

export const openCreateAssetSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_CREATE_ASSET_SIDEBAR,
  });
};

export const closeCreateAssetSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CREATE_ASSET_SIDEBAR,
  });
};
export const closeCreateNewCampaignSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_CREATE_NEW_CAMPAIGN_SIDEBAR,
  });
  closeOverlay();
};
export const openCreateNewCampaignSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.OPEN_CREATE_NEW_CAMPAIGN_SIDEBAR,
  });
  openOverlay();
};

export const enableStickyHeader = () => {
  store.dispatch({
    type: GLOBAL_ACTION.ENABLE_STICKY_HEADER,
  });
};

export const disableStickyHeader = () => {
  store.dispatch({
    type: GLOBAL_ACTION.DISABLE_STICKY_HEADER,
  });
};

// export const getUserEntities = () => {
//   // querySearchParams = querySearchParams.replaceAll(' ','%20');

//   return getUserEntitiesService()
//     .then((res: any) => {
//       const serializedData: IUserEntitiesItem = res.data;
//       store.dispatch({
//         type: USER_ENTITIES.LOAD_SUCCESS,
//         payload: serializedData,
//       });
//     })
//     .catch((err) => {
//       console.log(err);
//       console.log(err.response);
//       if (err.response?.status === 403) {
//         localStorage.removeItem("csrfToken");
//         window.location.href = "";
//       }
//       store.dispatch({
//         type: USER_ENTITIES.LOAD_FAIL,
//         payload: [],
//       });
//     });
// };

export const setConfirmBoxBackOverlay = (state: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.SET_CONFIRM_BACK_OVERLAY,
    payload: state,
  });
};

export const setMainNavBackOverlay = (state: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.SET_MAIN_NAV_DARK_OVERLAY,
    payload: state,
  });
};

export const setStickyHeaderBackOverlay = (state: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.SET_STICKY_HEADER_BACK_OVERLAY,
    payload: state,
  });
};

export const closeAdvancedSearchSidebar = () => {
  store.dispatch({
    type: GLOBAL_ACTION.CLOSE_ADVANCED_SEARCH_SIDEBAR,
  });
};

export const setAudienceFilterApplied = (state: boolean) => {
  store.dispatch({
    type: GLOBAL_ACTION.AUDIENCE_FILTERS_APPLIED,
    payload: state,
  });
};
